export default __webpack_public_path__ + "static/media/MP.78577739.ico";